import React from 'react';
import { createRoot } from 'react-dom/client';
import TagManager from '@sooro-io/react-gtm-module';
import * as Sentry from "@sentry/react";

import { App } from "./App";
import { loadTagManagerArgs } from "./config/gtm";

import './i18n';

Sentry.init({
  dsn: "https://b708378cf9bf4c326860afa6eab1e9fe@o479791.ingest.us.sentry.io/4507299706241024",
  integrations: [
    Sentry.browserTracingIntegration(),
  ],
  environment: 'production',
  tracesSampleRate: 0.1,
  normalizeDepth: 10,
 });

loadTagManagerArgs.then((tagManagerArgs) => (
  tagManagerArgs && TagManager.initialize(tagManagerArgs)
));

const container = document.getElementById('frontend-assistance-fnol');
const root = createRoot(container!);
root.render(<App />);
